import { c as _c } from "react/compiler-runtime";
import { FiCloud, FiMoon, FiSun } from "react-icons/fi";
import CollapsibleText from "@/components/ui/collapsible-text";
import type { AvailabilityAssignment } from "@/types/self-schedule";
import TimeButton from "./time-button";
import { TimeSlotGroup } from "./time-picker";
interface TimeSlot {
  start: Date;
  end: Date;
  assignments: AvailabilityAssignment[];
  locationId?: string | null;
}
interface TimeGroupProps {
  title: string;
  timeSlots: TimeSlot[];
  selectedDateTime: Date | null;
  onTimeSelect: (slot: TimeSlot) => void;
  maxVisibleSlots?: number;
  group?: TimeSlotGroup;
}

// Helper function to get the appropriate icon for a time slot
const TimeSlotIcon = t0 => {
  const $ = _c(3);
  const {
    group
  } = t0;
  if (group === TimeSlotGroup.morning) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <FiSun className="h-4 w-4 text-foreground-muted transition-colors duration-300 group-hover/time-button:fill-status-warning-text group-hover/time-button:text-status-warning-text" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  } else {
    if (group === TimeSlotGroup.afternoon) {
      let t1;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <FiCloud className="h-4 w-4 text-foreground-muted transition-colors duration-300 group-hover/time-button:fill-status-info-text group-hover/time-button:text-status-info-text" />;
        $[1] = t1;
      } else {
        t1 = $[1];
      }
      return t1;
    } else {
      if (group === TimeSlotGroup.evening) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <FiMoon className="h-4 w-4 text-foreground-muted transition-colors duration-300 group-hover/time-button:fill-foreground-muted group-hover/time-button:text-muted-foreground" />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    }
  }
};
const TimeGroup = t0 => {
  const $ = _c(26);
  const {
    title,
    timeSlots,
    selectedDateTime,
    onTimeSelect,
    maxVisibleSlots: t1,
    group
  } = t0;
  const maxVisibleSlots = t1 === undefined ? 3 : t1;
  if (timeSlots.length === 0) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== group || $[1] !== maxVisibleSlots || $[2] !== onTimeSelect || $[3] !== selectedDateTime || $[4] !== timeSlots || $[5] !== title) {
    const visibleSlots = timeSlots.slice(0, maxVisibleSlots);
    const hiddenSlots = timeSlots.slice(maxVisibleSlots);
    const hasHiddenSlots = hiddenSlots.length > 0;
    const t6 = group ?? TimeSlotGroup.morning;
    let t7;
    if ($[10] !== t6) {
      t7 = <TimeSlotIcon group={t6} />;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    if ($[12] !== t7 || $[13] !== title) {
      t5 = <p className="mb-2 text-body-strong text-muted-foreground flex items-center gap-1">{t7}{title}</p>;
      $[12] = t7;
      $[13] = title;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t2 = "grid grid-cols-3 gap-2";
    let t8;
    if ($[15] !== group || $[16] !== onTimeSelect || $[17] !== selectedDateTime) {
      t8 = (slot, index) => <TimeButton key={slot.start.getTime()} time={slot.start} isSelected={selectedDateTime !== null && selectedDateTime.getTime() === slot.start.getTime()} onClick={() => onTimeSelect(slot)} style={{
        animationDelay: `${index * 50}ms`
      }} group={group} />;
      $[15] = group;
      $[16] = onTimeSelect;
      $[17] = selectedDateTime;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    t3 = visibleSlots.map(t8);
    t4 = hasHiddenSlots && <CollapsibleText text={`View ${hiddenSlots.length} more`} textClassName="mt-0" className="col-span-3"><div className="grid grid-cols-3 gap-2 pt-2">{hiddenSlots.map((slot_0, index_0) => <TimeButton key={slot_0.start.getTime()} time={slot_0.start} isSelected={selectedDateTime !== null && selectedDateTime.getTime() === slot_0.start.getTime()} onClick={() => onTimeSelect(slot_0)} style={{
          animationDelay: `${index_0 * 20}ms`
        }} group={group} />)}</div></CollapsibleText>;
    $[0] = group;
    $[1] = maxVisibleSlots;
    $[2] = onTimeSelect;
    $[3] = selectedDateTime;
    $[4] = timeSlots;
    $[5] = title;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t6 = <div className={t2}>{t3}{t4}</div>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};
export default TimeGroup;